/**
 * Site branding — remobiles.com vs guyarepair SaaS.
 * Preview locale (localhost) = toujours Remobiles (projet remobiles.com).
 */
const host = typeof window !== 'undefined' ? window.location.hostname : '';

const isRemobiles =
  process.env.REACT_APP_SITE === 'remobiles' ||
  host.includes('remobiles') ||
  host.includes('r-e-mobiles') ||
  host === 'localhost' ||
  host === '127.0.0.1';

export const SITE = {
  isRemobiles,
  name: isRemobiles ? 'R.E.Mobiles' : 'GUYAREPAIR',
  subtitle: isRemobiles ? 'Resurrection Mobile' : 'Plateforme SaaS',
  accent: isRemobiles ? '#dc2626' : '#009b3a',
  accentLight: isRemobiles ? '#ef4444' : '#00d946',
  secondary: isRemobiles ? '#eab308' : '#fedd00',
  accentRgb: isRemobiles ? '220, 38, 38' : '0, 155, 58',
  loginAccent: isRemobiles ? '#dc2626' : '#00c853',
  loginFeatures: isRemobiles
    ? [
        { title: 'Réparations', desc: 'Suivi complet de chaque réparation, du diagnostic à la livraison.' },
        { title: 'Point de Vente', desc: 'Caisse intégrée, devis, factures et gestion des paiements.' },
        { title: 'Stock & Clients', desc: 'Gestion du stock, historique clients et programme de fidélité.' },
      ]
    : [
        { title: 'Multi-Entreprise', desc: 'Chaque entreprise dispose de son propre espace et de ses propres données isolées.' },
        { title: 'Gestion Complète', desc: 'Réparations, stock, clients, facturation et bien plus encore.' },
        { title: 'Sécurisé & Fiable', desc: 'Isolation stricte des données et chiffrement de bout en bout.' },
      ],
};
